import React, { useMemo } from 'react';
import { SelectValueViewer } from 'components';
import { CustomSelectProps } from 'components/CustomSelect/CustomSelect.props';
import { useWaterfallContext } from 'pages/Waterfall/data/WaterfallContext/WaterfallContext';

interface CaptableListValueViewerProps extends CustomSelectProps {
  childrenCapTables?: Array<{ id?: number; name?: string }>;
}

const CaptableListValueViewer = (props: CaptableListValueViewerProps) => {
  const { childrenCapTables = [] } = props;
  const { capTableList } = useWaterfallContext();

  const options = useMemo(() => {
    const allCaptables = [...capTableList, ...childrenCapTables];
    return allCaptables.map(ct => ({
      label: ct.name ?? '',
      value: ct.id?.toString() ?? '',
    }));
  }, [capTableList, childrenCapTables]);

  return <SelectValueViewer {...props} useAliasList={false} options={options} />;
};

export default CaptableListValueViewer;
